import axios from 'axios'
// axios 配置
axios.defaults.timeout = 5000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.baseURL = '//zhihui-saas.com';

axios.interceptors.request.use((config) => {
	console.log("axios config:  " + JSON.stringify(config));
	return config;
}, (error) => {
	console.log("错误的传参")
	return Promise.reject(error);
});

//返回状态判断
axios.interceptors.response.use((res) => {
	// Indicator.close();
	if (res.data.code != "I001000") {
		return Promise.reject(res);
	}
	return res;
}, (error) => {
	console.log("网络异常");
	// Indicator.close();
	return Promise.reject(error);
});



export function fetchPost(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, params).then(response => {
				resolve(response.data);
			}, err => {
				reject(err);
			})
			.catch((error) => {
				reject(error)
			})
	});
}

export function fetchGet(url, param) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: param
			})
			.then(response => {
				resolve(response.data)
			}, err => {
				reject(err)
			})
			.catch((error) => {
				reject(error)
			})
	})
}

export default {
	get(url) {
		if (url === '' || url == null ) return ;
		return fetchGet(url);
	},
	post(url, params) {
		if (url === '' || url == null ) return ;
		return fetchPost(url, params);
	},
	syncTime(param) {
		return fetchGet('/api/cooperation', param)
	},
}
